<template>
  <div class="flex flex-col">
    <div
      class="flex flex-row"
      :class="largeImage ? 'items-center gap-3' : 'items-start gap-4 mb-2'"
    >
      <NuxtLazyImg
        v-if="imageUrl"
        :src="String(imageUrl)"
        :alt="name + ' logo'"
        :width="largeImage ? 100 : undefined"
        :height="largeImage ? 100 : undefined"
        class="shrink-0 object-contain rounded-md"
        :class="largeImage ? 'size-[100px]' : 'max-h-[100px] h-auto w-auto'"
      />

      <div class="overflow-hidden min-w-0" :class="largeImage ? '' : 'pt-2'">
        <Heading
          :level="titleLevel"
          :title="name"
          h-class="text-lg font-medium"
          class="kft-heading--left text-stone-800 mb-0!"
          data-test-id="supplier-profile-title"
        />

        <div v-if="!isSubdomain" class="h4 space-x-5 flex text-sm">
          <div class="flex items-center">
            <IconShieldCheck class="mr-1 text-lime-600 w-4 h-4" />
            {{ $t('product.reviews.supplierVerifiedLabel') }}
          </div>
        </div>

        <div v-if="subtitle" class="mr-2 text-slate-500 flex items-center">
          <IconStar class="text-lime-600 h-4 mr-2" />
          {{ subtitle }}
        </div>
      </div>
    </div>
    <slot name="description"></slot>
  </div>
</template>
<script setup>
import IconStar from '~/components/icons/IconStar'
const isSubdomain = useIsSubdomain()

defineProps({
  imageUrl: { type: String, default: '', required: false },
  name: { type: String, default: '', required: false },
  subtitle: { type: String, default: '', required: false },
  titleLevel: { type: Number, default: 5, required: false },
  titleHClass: { type: String, default: '', required: false },
  largeImage: { type: Boolean, default: false },
})
</script>
<style lang="css" scoped>
:root {
  --heading-text-align: left;
}
</style>
